import { createSelector } from 'reselect';
import { initialState } from './reducer';

/**
 * Direct selector to the classes state domain
 */

const selectClassesDomain = state => state.classes || initialState;

/**
 * Other specific selectors
 */

const makeSelectLoading = () =>
  createSelector(
    selectClassesDomain,
    substate => substate.loading,
  );

const makeSelectError = () =>
  createSelector(
    selectClassesDomain,
    substate => substate.error,
  );

const makeSelectId = () =>
  createSelector(
    selectClassesDomain,
    substate => substate.id,
  );

const makeSelectFirstRender = () =>
  createSelector(
    selectClassesDomain,
    substate => substate.firstRender,
  );

const makeSelectItemsList = () =>
  createSelector(
    selectClassesDomain,
    substate => substate.itemsList,
  );

const makeSelectItemsListFirstElem = () =>
  createSelector(
    selectClassesDomain,
    substate => substate.firstElem,
    );

const makeSelectClass = () =>
  createSelector(
    selectClassesDomain,
    substate => substate.classDetail,
      );
    
/**
 * Default selector used by Classes
 */

const makeSelectClasses = () =>
  createSelector(
    selectClassesDomain,
    substate => substate,
  );

export default makeSelectClasses;
export {
  selectClassesDomain,
  makeSelectId,
  makeSelectFirstRender,
  makeSelectLoading,
  makeSelectError,
  makeSelectItemsList,
  makeSelectItemsListFirstElem,
  makeSelectClass,
};
